import { cn } from "@pax/ui";

/** A Pax credit: the gold coin struck with the globe. */
export function Coin({ className }: { className?: string }) {
  return (
    <img
      src="/images/pax-token-icon.png"
      alt=""
      aria-hidden
      className={cn("size-5 shrink-0 object-contain", className)}
    />
  );
}
